const INITIAL_STATE = {
  hierarquias: [],
  hierarquia: {},
  hierarquiaFiltro: ''
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'HIERARQUIAS_FETCHED': {
      let copyHierarquia = [...state.hierarquias]
      copyHierarquia = action.payload

      return { ...state, hierarquias: copyHierarquia }
    }
    case 'HIERARQUIA_FETCH': {      
      return { ...state, hierarquia: action.payload }
    }
    case 'HIERARQUIA_EDITAR': {
      let copyHierarquia = {...state.hierarquia}
      copyHierarquia = action.payload
      
      return { ...state, hierarquia: copyHierarquia }
    }
    case 'HIERARQUIA_CHANGE_INPUT': { 
      const hierarquiaCopy = action.payload
      return { ...state, hierarquiaFiltro: hierarquiaCopy }
    }
    case 'HIERARQUIA_LIMPAR_INPUT': { 
      const hierarquiaCopy = ''  
      return { ...state, hierarquiaFiltro: hierarquiaCopy }
    }
    default:
      return state
  }
}